export function inlineVideo() {
    const videos = document.querySelectorAll(".inline-video");

    for(const video of videos) {
        const playBtn = video.querySelector(".video-play");
        let isVideoPlaying = false;
        playBtn && playBtn.addEventListener("click", event => {
            event.preventDefault();
            if(isVideoPlaying) {
                return false;
            } else {
                const videoURL = playBtn.getAttribute("href");
                video.insertAdjacentHTML("beforeend", `
                    <iframe width="560" id="${videoURL}" height="315" src="${videoURL}?autoplay=1&controls=1&enablejsapi=1" frameborder="0" allow="autoplay"; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                `);
                video.classList.add("play");
                video.parentElement.focus();
                isVideoPlaying = true;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/modules/inline-video.js